import { connect } from 'react-redux';
import ForgotConfirm from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(ForgotConfirm);
